<!--赖传峰-->
<!--2022/1/24-->
<!--eslint-disable max-len-->
<template>
  <svg
    :height="size"
    :viewBox="`0 0 ${size} ${size}`"
    :width="size"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      :height="size"
      :rx="size / 2"
      :width="size"
      fill="white"
      fill-opacity="0.8"
    />
    <mask
      :height="size"
      :width="size"
      maskUnits="userSpaceOnUse"
      style="mask-type: alpha"
      x="0"
      y="0"
    >
      <rect
        :height="size"
        :rx="size / 2"
        :width="size"
        fill="white"
      />
    </mask>
    <g>
      <slot />
    </g>
  </svg>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = withDefaults(defineProps<{ size?: number }>(), { size: 72 })
const size = computed(() => props.size)
</script>
